module.exports = __webpack_public_path__ + "img/social_media_toutiao.9cd2f962.png";